<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:operation>
      <el-button type="primary" size="mini" @click="openAddDrawer">添加</el-button>
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="listLoading" :showActionColumn="true" @cell-click="handleCellClick">
      <template v-slot:action="scope">
        <el-button type="text" size="medium" @click="handelEdit(scope.scope.$index, scope.scope.row)">编辑</el-button>
      </template>
    </resource-list-page-content>
    <template v-slot:drawer>
      <product-add-drawer :drawer="addDrawer" @handleClose="handleAddClose" @refreshData="fetchData" />
      <product-edit-drawer :drawer="editDrawer" :product-id="editId" @handleClose="handleEditClose" @refreshData="fetchData" />
    </template>
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import ProductAddDrawer from './common/ProductAddDrawer'
import ProductEditDrawer from './common/ProductEditDrawer'
export default {
  name: 'AllProductList',
  components: {
    ResourceListLayout,
    ResourceListPageContent,
    ProductAddDrawer,
    ProductEditDrawer
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  watch: {
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchObj) {
        str += "&" + key + "=" + this.searchObj[key]
      }
      return str
    }
  },
  data () {
    return {
      title: '产品列表',
      pageData: [],
      listLoading: false,
      cols: [
        { label: '产品名称', prop: 'title', clickable: true },
        {label: '类目', prop: 'type'},
        { label: '上架', prop: 'on_sale' },
        { label: '销量', prop: 'sold_count' },
        { label: 'sku最低价', prop: 'price' }
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      searchObj: {
        title: '',
        on_sale: '',
        type: ''
      },
      addDrawer: false,
      editDrawer: false,
      editId: 0
    }
  },
  methods: {
    fetchData () {
      this.listLoading = true
      this.$axios.get('/api/admin/qyh_products?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData = data.data.data
            this.pageOption.total = data.data.total
          }
          this.listLoading = false
        })
    },
    handleCellClick ({ row, prop }) {
      if (prop === 'title') this.showProduct(row.id)
    },
    showProduct (productId) {
      // 获取目标路由的 URL
      const routeUrl = this.$router.resolve({
        path: `/qyh_product/${productId}`
      }).href;
      window.open(routeUrl, '_blank');
    },
    openAddDrawer () {
      this.addDrawer = true
    },
    handleAddClose (drawer) {
      this.addDrawer = drawer
    },
    handelEdit (index, row) {
      this.editId = row.id
      this.editDrawer = true
    },
    handleEditClose (drawer) {
      this.editDrawer = drawer
      this.editId = 0
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/all_products/AllProductList.vue